const runtimeData = window.pfandpiratData || {};

export const runtime = runtimeData;

export const bootstrapApiUrl = runtimeData.bootstrapApiUrl || '/wp-json/pfandpirat/v1/bootstrap';
export const entriesApiUrl = runtimeData.entriesApiUrl || '';
export const stepsApiUrl = runtimeData.stepsApiUrl || '';
export const drinksApiUrl = runtimeData.drinksApiUrl || '';
export const crewsApiUrl = runtimeData.crewsApiUrl || '';
export const bottleMessagesApiUrl = runtimeData.bottleMessagesApiUrl || '';
export const announcementsApiUrl = runtimeData.announcementsApiUrl || '';
export const piratenpostApiUrl = runtimeData.piratenpostApiUrl || '/wp-json/pfandpirat/v1/piratenpost';
export const leaderboardApiUrl = runtimeData.leaderboardApiUrl || '';
export const deliveryStoresApiUrl = runtimeData.deliveryStoresApiUrl || '/wp-json/pfandpirat/v1/delivery-stores';
export const avatarsApiUrl = runtimeData.avatarsApiUrl || '';
export const avatarSelectApiUrl = runtimeData.avatarSelectApiUrl || '';
export const mapViewPreferenceApiUrl = runtimeData.mapViewPreferenceApiUrl || '/wp-json/pfandpirat/v1/me/map-view-preference';
export const buildings3dPreferenceApiUrl = runtimeData.buildings3dPreferenceApiUrl || '/wp-json/pfandpirat/v1/me/3d-buildings-preference';
export const appDonationMarkApiUrl = runtimeData.appDonationMarkApiUrl || '/wp-json/pfandpirat/v1/pfandspenden/mark';
export const locationConsentApiUrl = runtimeData.locationConsentApiUrl || '/wp-json/pfandpirat/v1/me/location-consent';
export const profileVisitsLogApiUrl = runtimeData.profileVisitsLogApiUrl || '';
export const profileVisitsMeApiUrl = runtimeData.profileVisitsMeApiUrl || '';
export const referralsApiUrl = runtimeData.referralsApiUrl || '';
export const referralShareApiUrl = runtimeData.referralShareApiUrl || '';
export const expeditionsApiUrl = runtimeData.expeditionsApiUrl || '/wp-json/pfandpirat/v1/expeditions';
export const harborOrdersApiUrl = runtimeData.harborOrdersApiUrl || '/wp-json/pfandpirat/v1/harbor/orders';
export const harborDuelsApiUrl = runtimeData.harborDuelsApiUrl || '/wp-json/pfandpirat/v1/harbor/duels';
export const shipyardApiUrl = runtimeData.shipyardApiUrl || '/wp-json/pfandpirat/v1/shipyard';
export const shipGameApiUrl = runtimeData.shipGameApiUrl || '/wp-json/pfandpirat/v1/ship-game';
export const walletApiUrl = runtimeData.walletApiUrl || '/wp-json/pfandpirat/v1/wallet/me';
export const shopItemsApiUrl = runtimeData.shopItemsApiUrl || '/wp-json/pfandpirat/v1/shop/items';
export const shopPurchaseApiUrl = runtimeData.shopPurchaseApiUrl || '/wp-json/pfandpirat/v1/shop/purchase';
export const nonce = runtimeData.nonce || '';

export const publicQuickMarkApiUrl = runtimeData.publicQuickMarkApiUrl || '/wp-json/pfandpirat/v1/pfandspenden/quick-mark';
export const pfandspendePickupApiUrl = runtimeData.pfandspendePickupApiUrl || '/wp-json/pfandpirat/v1/pfandspenden-pickup';
export const eventsApiUrl = runtimeData.eventsApiUrl || '/wp-json/pfandpirat/v1/events';
export const activeEventApiUrl = runtimeData.activeEventApiUrl || '/wp-json/pfandpirat/v1/events/active';
export const isPublicQuickMark = runtimeData.isPublicQuickMark || false;
export const isLoggedIn = runtimeData.isLoggedIn || false;
export const quickMarkSource = runtimeData.quickMarkSource || '';
export const appUrl = runtimeData.appUrl || '/app/';
export const appPublicBaseUrl = runtimeData.appPublicBaseUrl || runtimeData.APP_PUBLIC_BASE_URL || appUrl;
export const websiteUrl = runtimeData.websiteUrl || '/';
export const impressumUrl = runtimeData.impressumUrl || '/impressum/';
export const loginUrl = runtimeData.loginUrl || '/wp-login.php';
export const quickMarkLogoUrl = runtimeData.quickMarkLogoUrl || runtimeData.logoUrl || '';
export const meApiUrl = runtimeData.meApiUrl || '/wp-json/pfandpirat/v1/me';
export const authStatusUrl = runtimeData.authStatusUrl || '/wp-admin/admin-ajax.php?action=pfp_auth_status';
export const socialSharingEnabled = runtimeData.socialSharingEnabled !== false;
export const publicFundShareEnabled = runtimeData.publicFundShareEnabled !== false;
export const shareWhatsAppEnabled = runtimeData.shareWhatsAppEnabled !== false;
export const shareInstagramEnabled = runtimeData.shareInstagramEnabled !== false;
export const shareFacebookEnabled = runtimeData.shareFacebookEnabled !== false;
export const shareEmailEnabled = runtimeData.shareEmailEnabled !== false;
export const shareImageEnabled = runtimeData.shareImageEnabled === true;

const fallbackName =
  runtimeData.user_name ||
  runtimeData.display_name ||
  'Pirat';

export const currentUser = {
  id: Number(runtimeData.user_id || 0),
  name: fallbackName
};

export function getRuntime() {
  return runtimeData;
}
